import { Component, Input } from '@angular/core';

@Component({
  selector: 'nns-toasts',
  template: `
    <nns-toast *ngFor="let toast of toasts" [toast]="toast"></nns-toast>
  `,
  styles: [`
    :host {
      z-index: 1000;
      position:fixed;
    }

    :host nns-toast:first-child {margin-top:0;}
    :host nns-toast:last-child {margin-bottom:0;}
    `]
})
export class ToastsComponent {
  @Input() toasts;
}
